import { palette } from '@/theme/constants';
import { theme } from '@/theme';

const storeButtonBaseSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '6.25rem',
  backgroundColor: palette.primary,
  color: palette.white,
  lineHeight: 1,
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  border: 'none',
  cursor: 'pointer',
  fontFamily: theme.typography.fontFamily,
  boxShadow: '0px 4px 14px 0px rgba(0, 114, 206, 0.2)',
  transition: 'box-shadow 0.2s ease-in-out, background-color 0.2s ease-in-out',
  textTransform: 'none',
  '&:hover': {
    color: palette.white,
    backgroundColor: palette.primary,
    boxShadow: '0px 6px 18px 0px rgba(0, 114, 206, 0.28)',
  },
} as const;

export const styles = {
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1200,
    width: '100%',
    pt: 'env(safe-area-inset-top, 0px)',
    background: 'linear-gradient(87.36deg, rgba(216, 232, 246, 0.97) 2.61%, rgba(187, 223, 255, 0.97) 98.24%)',
    backdropFilter: 'blur(1.562rem)',
    WebkitBackdropFilter: 'blur(1.562rem)',
    borderBottom: '2px solid #0000001A',
    boxShadow: '0px 8px 30px 0px rgba(33, 45, 109, 0.08)',
  },
  inner: {
    width: '100%',
    height: 56,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: { xs: 0.5, sm: 1 },
    px: { xs: 1, sm: 1.5 },
    boxSizing: 'border-box',
  },
  phoneIcon: {
    display: { xs: 'none', sm: 'flex' },
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: palette.white,
    boxShadow: '0px 4px 14px 0px rgba(33, 45, 109, 0.1)',
    flexShrink: 0,
  },
  message: {
    flex: '1 1 auto',
    minWidth: 0,
    lineHeight: 1.2,
    fontSize: { xs: '0.6875rem', sm: '0.8125rem' },
    fontWeight: 500,
    color: palette.background,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 0.75, sm: 1.25 },
    flexShrink: 0,
    ml: { xs: 0.5, sm: 'auto' },
  },
  storeIcon: {
    display: 'inline-flex',
    mr: 0.5,
    lineHeight: 0,
  },
  dismissButton: {
    color: palette.gray,
    p: 0.5,
    flexShrink: 0,
    minWidth: 40,
    minHeight: 40,
    '&:hover': {
      color: palette.background,
      backgroundColor: 'rgba(33, 45, 109, 0.06)',
    },
  },
  installButton: {
    ...storeButtonBaseSx,
    px: 1.75,
    py: 0.75,
    minHeight: 36,
    minWidth: 88,
  },
  installLabel: {
    color: 'inherit',
    lineHeight: 1,
  },
  storeLink: (compact: boolean) => ({
    ...storeButtonBaseSx,
    px: compact ? 1 : 1.25,
    py: 0.5,
    minWidth: compact ? 64 : 'auto',
    minHeight: compact ? 32 : 36,
    fontWeight: 500,
    fontSize: compact ? '0.6875rem' : '0.75rem',
  }),
};
